import { useEffect, useState } from 'react'
import './popup-promo.component.css'
import { LOCAL_STORAGE_LOYALTY_KEY_PREFIX } from '../../../constants'
import { Portal } from 'react-portal'
import HtmlRendererComponent from '../html-renderer/html-renderer.component'
import { Link } from 'react-router-dom'
import { gsap } from 'gsap'
import { closeIcon, badgeIcon } from '../../icons'

const PopupPromoComponent = (props) => {
  const { popupPromo, restaurantSlug } = props
  const [showModal, setShowModal] = useState()
  const [showSidebar, setShowSidebar] = useState()
  const { header, copy, url } = popupPromo

  // Check if we should display full modal/sidebar
  useEffect(() => {
    const modalKey = `${LOCAL_STORAGE_LOYALTY_KEY_PREFIX}_modal_${restaurantSlug}`
    const modal = window.localStorage.getItem(modalKey)
    const sidebarKey = `${LOCAL_STORAGE_LOYALTY_KEY_PREFIX}_sidebar_${restaurantSlug}`
    const sidebar = window.sessionStorage.getItem(sidebarKey)

    if (modal === null) {
      // Show
      setTimeout(handleShowModal, 3000)
    } else if (sidebar === null) {
      setTimeout(handleShowSidebar, 3000)
    }
  }, [restaurantSlug])

  const handleShowModal = () => {
    setShowModal(true)
    setTimeout(() => {
      gsap.to('.prg-popup-promo-container', {
        opacity: 1,
        ease: 'power2.easeIn',
        duration: 0.5,
      })

      gsap.to('.prg-popup-promo-content', {
        opacity: 1,
        ease: 'elastic.out(1,0.6)',
        duration: 0.6,
        transform: 'translate(-50%, -50%)',
        delay: 0.2,
      })
    }, 250)
  }

  const handleShowSidebar = () => {
    setShowSidebar(true)
    setTimeout(() => {
      gsap.to('.prg-sidebar-promo', {
        opacity: 1,
        ease: 'elastic.out(1,0.6)',
        duration: 1,
      })
    }, 250)
  }

  const handleCloseModal = (didViewLink = false) => {
    // Set viewed
    const key = `${LOCAL_STORAGE_LOYALTY_KEY_PREFIX}_modal_${restaurantSlug}`
    window.localStorage.setItem(key, true)

    // Close
    gsap.to('.prg-popup-promo-content', {
      opacity: 0,
      ease: 'power2.easeInOut',
      duration: 0.2,
      transform: 'translate(-50%, -50%) scale(0.9)',
    })

    gsap.to('.prg-popup-promo-container', {
      opacity: 0,
      ease: 'power2.easeIn',
      duration: 0.3,
      delay: 0.1,
      onComplete: () => {
        setTimeout(() => {
          setShowModal(false)

          // Maybe show sidebar
          const sidebarKey = `${LOCAL_STORAGE_LOYALTY_KEY_PREFIX}_sidebar_${restaurantSlug}`
          const sidebar = window.sessionStorage.getItem(sidebarKey)
          if (!didViewLink && sidebar === null) {
            handleShowSidebar()
          }
        })
      },
    })
  }

  const handleCloseSidebar = () => {
    // Set viewed
    const key = `${LOCAL_STORAGE_LOYALTY_KEY_PREFIX}_sidebar_${restaurantSlug}`
    window.sessionStorage.setItem(key, true)

    // Close
    gsap.to('.prg-sidebar-promo', {
      opacity: 0,
      ease: 'power2.easeIn',
      duration: 0.3,
      onComplete: () => {
        setTimeout(() => {
          setShowSidebar(false)
        })
      },
    })
  }

  return (
    <div className="prg-popup-promo">
      {showModal && (
        <Portal>
          <div
            className="prg-popup-promo-container"
            onClick={() => handleCloseModal(false)}
          >
            <div
              className="prg-popup-promo-content"
              onClick={(e) => e.stopPropagation()}
            >
              <h2>{header}</h2>
              <HtmlRendererComponent copy={copy} />
              <Link
                target="_blank"
                to={url}
                className="prg-primary-btn"
                onClick={() => handleCloseModal(true)}
              >
                Sign up!
              </Link>
              <button
                className="prg-text-primary-btn"
                onClick={() => handleCloseModal(false)}
              >
                No thanks
              </button>
            </div>
          </div>
        </Portal>
      )}
      {showSidebar && (
        <Portal node={document?.body}>
          <div className="prg-sidebar-promo">
            <button onClick={handleCloseSidebar}>{closeIcon}</button>
            <Link target="_blank" to={url} onClick={handleCloseSidebar}>
              {header}
            </Link>
            {badgeIcon}
          </div>
        </Portal>
      )}
    </div>
  )
}

export default PopupPromoComponent
